/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Ask_Questions_Label_RecommendedInputs */

const es_components_ask_questions_label_recommended = /** @type {(inputs: Components_Ask_Questions_Label_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recomendado`)
};

const en_components_ask_questions_label_recommended = /** @type {(inputs: Components_Ask_Questions_Label_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommended`)
};

/**
* | output |
* | --- |
* | "Recommended" |
*
* @param {Components_Ask_Questions_Label_RecommendedInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_ask_questions_label_recommended = /** @type {((inputs?: Components_Ask_Questions_Label_RecommendedInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Ask_Questions_Label_RecommendedInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_ask_questions_label_recommended(inputs)
	return en_components_ask_questions_label_recommended(inputs)
});
export { components_ask_questions_label_recommended as "components.ask_questions.label.recommended" }